/**
 * WallTile - Impassable wall obstacle
 */

import { BaseTile, TextureDescriptor } from "./BaseTile";
import { TILE } from "../constants/gameConstants";
import { TileIndex } from "../types";

export class WallTile extends BaseTile {
  constructor({ col, row, id }: { col: number; row: number; id?: string }) {
    super(id ?? `wall-${col}-${row}`, col, row);
  }

  tileType(): TileIndex {
    return TILE.WALL;
  }

  textureDescriptor(): TextureDescriptor {
    return { type: "png", path: "tiles/wall.png" };
  }

  // Default isEntity() returns false (static tile)
  // Default move() returns { type: "wait" }

  clone(): WallTile {
    const copy = new WallTile({ col: this.col, row: this.row, id: this.id });
    copy.sprite = this.sprite;
    return copy;
  }

  toJSON(): Record<string, any> {
    return { type: "wall", id: this.id, col: this.col, row: this.row };
  }
}
